import { render, staticRenderFns } from "./otherInfo.vue?vue&type=template&id=5eabba63&scoped=true&"
import script from "./otherInfo.vue?vue&type=script&lang=js&"
export * from "./otherInfo.vue?vue&type=script&lang=js&"
import style0 from "./otherInfo.vue?vue&type=style&index=0&id=5eabba63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eabba63",
  null
  
)

export default component.exports